import { render, staticRenderFns } from "./testpaper.vue?vue&type=template&id=3c30b91c&scoped=true&"
import script from "./testpaper.vue?vue&type=script&lang=js&"
export * from "./testpaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c30b91c",
  null
  
)

export default component.exports